import React, {useEffect, useState} from "react"
import {Backdrop} from "@mui/material"
import {Container, InnerContainer} from "./component"
import {OVERLAY_TIMEOUT, PRIMARY_NAV_ITEM_HOVER_DELAY} from "../../../../config/constants"
import {getTestingVariant} from "../../../../utils/testingVariant"

export type OverlayProps = {
    open: boolean
    children: JSX.Element
    handleClose: () => void
    hideOverlay: boolean
}
const innerOverlayDefaultProps = {
    disableRestoreFocus: true,
    disableAutoFocus: true,
    disableEnforceFocus: false,
    disablePortal: true,
    keepMounted: false,
    closeAfterTransition: true,
    disableScrollLock: true,
    disableEscapeKeyDown: false,
}

let timerId: NodeJS.Timeout | number = 0

const SecondaryNavOverlay = ({open, children, hideOverlay, handleClose}: OverlayProps) => {
    const [delayedOpen, setOpen] = useState(false)
    useEffect(() => {
        timerId = setTimeout(() => setOpen(open), PRIMARY_NAV_ITEM_HOVER_DELAY)
        return () => {
            handleClose()
            clearTimeout(timerId as NodeJS.Timeout)
        }
    }, [open, handleClose])

    return (
        // eslint-disable-next-line react/jsx-no-useless-fragment
        <>
            {!hideOverlay ? (
                <Container
                    {...innerOverlayDefaultProps}
                    data-testid="overlay"
                    data-testing-variant={getTestingVariant()}
                    open={delayedOpen}
                    BackdropComponent={Backdrop}
                    BackdropProps={{timeout: OVERLAY_TIMEOUT}}
                    onClose={handleClose}
                >
                    <InnerContainer data-testid="secondary-meganav-wide">{children}</InnerContainer>
                </Container>
            ) : null}
        </>
    )
}

export default SecondaryNavOverlay
